import { useState } from "react";
import { createStyles, Navbar, Group, Code } from "@mantine/core";
import {
  IconChartPie2,
  IconUsers,
  IconSchool,
  IconHelp,
  IconTag,
  IconBell,
  IconFileInfo,
  IconChalkboard,
  IconChartBar,
  IconCreditCard,
  IconCalendarStats,
  IconVideo,
  IconClockHour4,
  IconReportMoney,
  IconCash,
  IconStar,
  IconSettings
} from "@tabler/icons";
import { Link } from "react-router-dom";
import styled from "styled-components";

const useStyles = createStyles((theme, _params) => ({
  header: {
    paddingBottom: theme.spacing.md,
    marginBottom: theme.spacing.md * 1.5,
    borderBottom: `1px solid ${
        theme.colorScheme === "dark"
            ? theme.colors.dark[4]
            : theme.colors.gray[2]
    }`,
  },

  footer: {
    paddingTop: theme.spacing.md,
    marginTop: theme.spacing.md,
    borderTop: `1px solid ${
        theme.colorScheme === "dark"
            ? theme.colors.dark[4]
            : theme.colors.gray[2]
    }`,
  },

  link: {
    ...theme.focusStyles,
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    fontSize: theme.fontSizes.sm,
    borderRadius: theme.radius.sm,
    fontWeight: 500,

    "&:hover": {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.colors.gray[1],
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[9],

      "& $linkIcon": {
        color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[9],
      },
    },
  },

  linkIcon: {
    marginRight: theme.spacing.sm,
    color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[6],
  },

  linkActive: {
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.colors.gray[1],
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[9],

    "& $linkIcon": {
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[9],
    },
  },
}));

const StyledLink = styled(Link)`
  width: 100%;
  padding: 10px 12px;
  color: #868e96;

  &:hover {
    color: #ae094d;
    text-decoration: none;
  }

  &:focus {
    color: #ae094d !important;
    text-decoration: none;
  }
`;

const data = [
  { url: "/", name: "Dashboard", icon: IconChartPie2 },
  { url: "/trainers", name: "Tutor List", icon: IconUsers },
  { url: "/available-trainers", name: "Available Tutors", icon: IconClockHour4 },
  { url: "/students", name: "Student List", icon: IconSchool },
  { url: "/supports", name: "Support", icon: IconHelp },
  { url: "/discounts", name: "Discounts", icon: IconTag },
  { url: "/notification", name: "Notification", icon: IconBell },
  { url: "/infoRequest", name: "Request for Information", icon: IconFileInfo },
  { url: "/manager", name: "Manager and Students", icon: IconChalkboard },
  { url: "/report", name: "Appointment Report", icon: IconChartBar },
  { url: "/subscription-report", name: "Subscription Report", icon: IconCreditCard },
  { url: "/monthly-report", name: "Monthly Subscription Report", icon: IconCalendarStats },
  { url: "/meeting-tracking", name: "Meeting Tracking", icon: IconVideo },
  { url: "/video-provider", name: "Görüşme Sistemi", icon: IconSettings },
  {
    name: "Öğretmen İşlemleri",
    icon: IconReportMoney,
    children: [
      { url: "/payroll", name: "Maaş Yönetimi", icon: IconCash },
      { url: "/payroll/performance", name: "Performans", icon: IconStar },
    ],
  },
  {
    name: "Okul Düzenle",
    icon: IconSchool,
    children: [
      { url: "/school/add", name: "Okul Ekle", icon: IconSchool },
      { url: "/school/branches", name: "Sınıf / Şube Ata", icon: IconChalkboard },
      { url: "/school/students", name: "Öğrenci Ata", icon: IconUsers },
      { url: "/school/overview", name: "Okul Öğrencileri", icon: IconSchool },
      { url: "/school/files", name: "Dosya Yönetimi", icon: IconFileInfo },
    ],
  },
];

export function NavbarSimple() {
  const { classes, cx } = useStyles();
  const [active, setActive] = useState("");
  const [openGroup, setOpenGroup] = useState("");

  const renderLeaf = (item, nested = false) => (
      <a
          key={item.url}
          className={cx(classes.link, {
            [classes.linkActive]: item.name === active,
          })}
          onClick={() => {
            setActive(item.name);
          }}
      >
        <StyledLink to={item.url} style={nested ? { paddingLeft: 34 } : undefined}>
          <item.icon className={classes.linkIcon} size={nested ? 20 : 24} />
          <span>{item.name}</span>
        </StyledLink>
      </a>
  );

  const links = data.map((item) => {
    if (!item.children) return renderLeaf(item);

    const isOpen = openGroup === item.name;
    return (
        <div key={item.name}>
          <a
              className={cx(classes.link)}
              style={{ cursor: "pointer", display: "flex", alignItems: "center", padding: "10px 12px", color: "#868e96" }}
              onClick={() => setOpenGroup(isOpen ? "" : item.name)}
          >
            <item.icon className={classes.linkIcon} size={24} />
            <span style={{ flex: 1 }}>{item.name}</span>
            <span>{isOpen ? "▾" : "▸"}</span>
          </a>
          {isOpen && item.children.map((child) => renderLeaf(child, true))}
        </div>
    );
  });

  return (
      <Navbar p="md">
        <Navbar.Section grow>
          <Group className={classes.header} position="apart">
            <h3 style={{ color: "#AE094D" }}>QADMIN</h3>
            <Code sx={{ fontWeight: 700 }}>v0.2.0</Code>
          </Group>
          {links}
        </Navbar.Section>
      </Navbar>
  );
}
